export default __webpack_public_path__ + "static/media/materialdesignicons-webfont.af0830ad.woff2";